module.exports = __webpack_public_path__ + "static/media/tables.a04fb394.svg";